export default "__VITE_ASSET__WRBgGcYu__"